import React from "react";

import { Layout } from "../../components";
import { Box, Center } from "../../components/ui";

import styles from "./index.module.css";

const HelpPage = () => {
  const BulletPoint = () => (
    <div>
      <div className={styles.bulletPoint} />
    </div>
  );

  return (
    <Layout>
      <Center>
        <h1 className={styles.title}>Помощь</h1>
        <Box className={styles.contentBox}>
          <p className={styles.paragraph}>
            С помощью формы личного кабинета пользователю доступны его
            медиапакеты на посещенных активностях заказанные и оплаченные в{" "}
            <b>Skypark Sochi</b>.
          </p>
          <ul className={styles.list}>
            <li className={styles.listItem}>
              <BulletPoint />
              Доступны функции просмотра и скачивания медиа контента.
            </li>
            <li className={styles.listItem}>
              <BulletPoint />
              Хранение медиа контента ограничено по времени, полная информация
              на главной странице.
            </li>
            <li className={styles.listItem}>
              <BulletPoint />
              Любые вопросы и пожелания по полученному контенту пользователь
              может задать через данную форму , а также по телефону клиентской
              службы в разделе «контакты»."
            </li>
          </ul>
        </Box>
      </Center>
    </Layout>
  );
};

export default HelpPage;
